module.exports = __webpack_public_path__ + "img/tel.458d5776.png";